export const receiveProductTemplates = (state, action) => action.templates;
